export default {
  /** Estatisticas company  */
  getStaticComapny () {
    /** parametros de busca */
    const prepareSearch = {
      country_register: this.countryRegister,
      type: this.type
    }
    this.$http.post('v1/scheduling/see/total-all', prepareSearch)
    .then((data) => {
      this.companyStatitics = data.data
    })
    .catch(({data, meta}) => {
      this.errors = data
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/components/statistics/resources/methods.js